import { connect } from 'react-redux'

import { RootState } from '../../../store'

import { addNewUser } from '../../../actions'

import AddUser from '../../../components/pages/ManageAgency/AddUser'

const mapStateToProps = (state: RootState) => {
    return {
        errorState: state.users.users.error,
        successState: state.users.users.success,
    }
}

export default connect(mapStateToProps, { addNewUserTrigger: addNewUser })(AddUser)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/ManageAgency/AddUser.tsx